<template>
<div class="progress" :class="good ? 'good' : 'bad'">
  <span :class="value > 0 ? 'active' : '' "></span>
  <span :class="value > 1 ? 'active' : '' "></span>
  <span :class="value > 2 ? 'active' : '' "></span>
  <span :class="value > 3 ? 'active' : '' "></span>
  <span :class="value > 4 ? 'active' : '' "></span>
  <span :class="value > 5 ? 'active' : '' "></span>
  <span :class="value > 6 ? 'active' : '' "></span>
  <span :class="value > 7 ? 'active' : '' "></span>
  <span :class="value > 8 ? 'active' : '' "></span>
  <span :class="value > 9 ? 'active' : '' "></span>
</div>
</template>
<script>
export default {
  name: 'progress',
  components:{},
  data:()=>({}),
  props:{
    good: {type: Boolean, default: true},
    value: {type: Number, default: 0}
  },
  methods:{},
  created(){},
  mounted(){},
  watch:{}
}
</script>
<style lang="sass" scoped>
.progress
  display: grid
  grid-template-columns: repeat(10, 20px)
  column-gap: 5px
  &.good
    span.active
      background-color: green
  &.bad
    span.active
      background-color: red
  span
    width: 20px
    height: 5px
    background-color: rgba(0,0,0,0.4)
    border-radius: 10px
</style>
